import React, { useEffect, useState } from 'react';
import { Package, X } from 'lucide-react';
import api from '../../api/client';
import SlideFoto from '../../components/SlideFoto';

const API_BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/api$/, '');
const fmt = (n) => `€${(n||0).toFixed(2)}`;

export default function CatalogoSolaLettura() {
  const [products, setProducts] = useState([]);
  const [search, setSearch]     = useState('');
  const [preview, setPreview]   = useState(null);

  useEffect(() => {
    api.get('/products').then(r => setProducts(r.data)).catch(console.error);
  }, []);

  const filtered = products.filter(p =>
    p.nome.toLowerCase().includes(search.toLowerCase()) ||
    p.category?.nome?.toLowerCase().includes(search.toLowerCase())
  );

  const grouped = filtered.reduce((g, p) => {
    const k = p.category?.nome || 'Altro';
    if (!g[k]) g[k] = []; g[k].push(p); return g;
  }, {});

  return (
    <div>
      <div style={{ marginBottom:'24px' }}>
        <h1 style={s.title}>CATALOGO PRODOTTI</h1>
        <p style={s.sub}>{products.length} prodotti disponibili</p>
      </div>

      <input style={s.search} placeholder="Cerca prodotto..."
        value={search} onChange={e => setSearch(e.target.value)}/>

      {Object.entries(grouped).map(([cat, prods]) => (
        <div key={cat} style={{ marginBottom:'28px' }}>
          <div style={s.catHeader}>{cat}</div>
          <div style={s.grid}>
            {prods.map(p => {
              const img = p.immagine_url ? `${API_BASE}${p.immagine_url}` : null;
              return (
                <div key={p.id} style={{ ...s.card, ...(p.acquistabile === false ? { opacity:0.65 } : {}) }} onClick={() => setPreview(p)}>
                  <div style={s.cardImg}>
                    {img
                      ? <img src={img} alt={p.nome} style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                      : <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%' }}>
                          <Package size={36} color="var(--text-dim)"/>
                        </div>}
                    {p.personalizzabile && <div style={s.stampaBadge}>STAMPA NOME</div>}
                    {p.galleria?.length > 1 && <div style={{ position:'absolute', right:'6px', bottom:'6px', background:'rgba(0,0,0,.6)', color:'#fff', fontSize:'10px', fontWeight:700, padding:'2px 7px', borderRadius:'6px' }}>{p.galleria.length} FOTO</div>}
                    {p.acquistabile === false && <div style={s.nonAcqBadge}>NON ACQUISTABILE</div>}
                  </div>
                  <div style={s.cardBody}>
                    <div style={s.prodNome}>{p.nome}</div>
                    <div style={s.prodPrezzo}>{fmt(p.prezzo_vendita_ivato)}</div>
                    {p.personalizzabile && (
                      <div style={{ fontSize: 'var(--font-size-xs)', color:'#F4600C', marginBottom:'6px' }}>
                        + €5 con stampa nome
                      </div>
                    )}
                    {/* Taglie disponibili */}
                    <div style={{ display:'flex', flexWrap:'wrap', gap:'4px' }}>
                      {p.variants?.filter(v=>v.attiva).map(v => (
                        <span key={v.id} style={{
                          ...s.tagliaPill,
                          ...(v.inventory?.quantita_disponibile > 0 ? s.tagliaDisp : s.tagliaOos)
                        }}>
                          {v.taglia}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {filtered.length === 0 && (
        <div style={{ textAlign:'center', color:'var(--text-dim)', padding:'60px 0' }}>
          <Package size={40} color="var(--text-dim)"/>
          <p style={{ marginTop:'12px' }}>Nessun prodotto trovato</p>
        </div>
      )}

      {preview && (
        <div style={s.overlay} onClick={e => e.stopPropagation()}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <button style={s.closeBtn} onClick={() => setPreview(null)}><X size={18}/></button>
            <div style={s.modalImg}>
              {(preview.galleria?.length || preview.immagine_url)
                ? <SlideFoto alt={preview.nome} foto={(preview.galleria?.length ? preview.galleria.map(g => g.url) : [preview.immagine_url]).map(u => `${API_BASE}${u}`)}/>
                : <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%' }}>
                    <Package size={48} color="var(--text-dim)"/>
                  </div>}
              {preview.personalizzabile && <div style={s.stampaBadge}>STAMPA NOME</div>}
              {preview.acquistabile === false && <div style={{ ...s.nonAcqBadge, top:'12px', right:'auto', left:'12px' }}>NON ACQUISTABILE</div>}
            </div>
            <div style={s.modalBody}>
              <div style={s.prodNome}>{preview.nome}</div>
              <div style={s.prodPrezzo}>{fmt(preview.prezzo_vendita_ivato)}</div>
              {preview.acquistabile === false && (
                <div style={s.nonAcqNota}>Al momento non è possibile ordinare questo articolo. Puoi comunque consultarlo qui.</div>
              )}
              {preview.personalizzabile && (
                <div style={{ fontSize: 'var(--font-size-xs)', color:'#F4600C', marginBottom:'8px' }}>
                  + €5 con stampa nome
                </div>
              )}
              {preview.descrizione && (
                <div style={{ fontSize:'var(--font-size-sm)', color:'var(--text-muted)', marginBottom:'12px', lineHeight:'1.5' }}>{preview.descrizione}</div>
              )}
              <div style={{ display:'flex', flexWrap:'wrap', gap:'6px' }}>
                {preview.variants?.filter(v=>v.attiva).map(v => {
                  const disp = v.inventory?.quantita_disponibile || 0;
                  return (
                    <div key={v.id} style={{ background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'6px', padding:'6px 10px', textAlign:'center', minWidth:'55px' }}>
                      <div style={{ fontWeight:'700', fontSize:'var(--font-size-sm)' }}>{v.taglia}</div>
                      <div style={{ fontSize: 'var(--font-size-xs)', color: disp > 0 ? '#22C55E' : '#F59E0B', marginTop:'2px' }}>
                        {disp > 0 ? `${disp} disp.` : 'su ord.'}
                      </div>
                    </div>
                  );
                })}
              </div>
              {preview.acquistabile !== false && preview.variants?.some(v => v.attiva && (v.inventory?.quantita_disponibile || 0) === 0) && (
                <div style={s.backorderNota}>Alcune taglie sono esaurite: se le ordini, i tempi di consegna saranno più lunghi del solito.</div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  title:      { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub:        { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginTop:'4px' },
  search:     { width:'100%', background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'8px', padding:'11px 16px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', marginBottom:'24px', boxSizing:'border-box' },
  catHeader:  { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-lg)', fontWeight:'700', letterSpacing:'2px', color:'#F4600C', marginBottom:'12px', paddingBottom:'6px', borderBottom:'1px solid var(--border)' },
  grid:       { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(200px, 1fr))', gap:'14px' },
  card:       { background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', overflow:'hidden', cursor:'pointer', transition:'border-color 0.15s, background-color 0.15s' },
  cardImg:    { height:'150px', background:'var(--bg)', position:'relative', overflow:'hidden' },
  stampaBadge:{ position:'absolute', bottom:'6px', left:'6px', background:'#F4600C', color:'#fff', fontSize: 'var(--font-size-xs)', fontWeight:'700', padding:'3px 7px', borderRadius:'4px' },
  nonAcqBadge:{ position:'absolute', top:'6px', right:'6px', background:'#EF4444', color:'#fff', fontSize: 'var(--font-size-xs)', fontWeight:'700', padding:'3px 7px', borderRadius:'4px' },
  nonAcqNota: { background:'#EF444415', border:'1px solid #EF444430', borderRadius:'8px', padding:'8px 10px', color:'#EF4444', fontSize:'var(--font-size-xs)', fontWeight:'600', marginBottom:'10px' },
  backorderNota:{ background:'#F59E0B15', border:'1px solid #F59E0B30', borderRadius:'8px', padding:'8px 10px', color:'#F59E0B', fontSize:'var(--font-size-xs)', fontWeight:'600', marginTop:'10px' },
  cardBody:   { padding:'14px' },
  prodNome:   { fontWeight:'700', fontSize:'var(--font-size-sm)', marginBottom:'4px', lineHeight:'1.3' },
  prodPrezzo: { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-xl)', fontWeight:'800', color:'#F4600C', marginBottom:'8px' },
  tagliaPill: { borderRadius:'4px', padding:'2px 7px', fontSize: 'var(--font-size-xs)', fontWeight:'700', border:'1px solid' },
  tagliaDisp: { background:'#22C55E15', color:'#22C55E', borderColor:'#22C55E30' },
  tagliaOos:  { background:'var(--bg-input)', color:'var(--text-dim)', borderColor:'var(--border2)' },
  overlay:    { position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'20px', boxSizing:'border-box' },
  modal:      { background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'14px', width:'100%', maxWidth:'420px', maxHeight:'90vh', overflowY:'auto', position:'relative' },
  closeBtn:   { position:'absolute', top:'12px', right:'12px', background:'rgba(0,0,0,0.5)', border:'none', borderRadius:'50%', width:'32px', height:'32px', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', cursor:'pointer', zIndex:1 },
  modalImg:   { height:'260px', background:'var(--bg)', position:'relative', overflow:'hidden', borderRadius:'14px 14px 0 0' },
  modalBody:  { padding:'18px 20px 20px' },
};
